/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Lush_Rosy_Ox_BoltInputs */

const en_lush_rosy_ox_bolt = /** @type {(inputs: Lush_Rosy_Ox_BoltInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Add ${i?.count} Manager`)
};

const de_lush_rosy_ox_bolt = /** @type {(inputs: Lush_Rosy_Ox_BoltInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Manager hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add {count} Manager" |
*
* @param {Lush_Rosy_Ox_BoltInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const lush_rosy_ox_bolt = /** @type {((inputs: Lush_Rosy_Ox_BoltInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lush_Rosy_Ox_BoltInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lush_rosy_ox_bolt(inputs)
	return de_lush_rosy_ox_bolt(inputs)
});